<template>
  <div>
    <van-nav-bar
      class="backBox"
      title="意见反馈"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="content_box">
      <div class="feedback_box">
        <van-form @submit="onSubmit">
          <textarea
            v-model="textareaVal"
            class="input-fault-case"
            placeholder="请输入反馈意见"
            placeholder-class="input-fault-case-placeholder"
            maxlength="300"
            @change="faultCase"
          ></textarea>
          <div class="upload-fault-image-hint">
            请上传图片（最多上传{{ maxImageNum }}张）
          </div>
          <!-- <div class="image-list-parent">
            <div v-for="item in faultImage" :key="item.id" class="image-item">
              <div
                class="delete-image iconfont icon-shanchu"
                @click="deleteImage"
              ></div>
              <img
                class="fault-image"
                mode="aspectFill"
                @click="previewImage"
                :src="faultImage[index]"
              />
            </div>
          </div> -->
          <div
            v-if="maxImageNum > faultImage.length"
            class="upload-image-btn"
            @click="chooseImage"
          >
            <!-- <div class="upload-btn-icon iconfont icon-paizhao"></div>
            <text class="upload-btn-text">请上传照片</text> -->

            <van-field name="uploader" label="">
              <template #input>
                <van-uploader v-model="uploader" :before-read="beforeRead" :max-count="5" />
              </template>
            </van-field>
          </div>

          <div class="anonymous-wrap">
            <van-field name="checkbox" label="">
              <template #input>
                <van-checkbox
                  class="anonymousBtn"
                  name="1"
                  v-model="anonymous"
                  @change="getAnonymous"
                  shape="square"
                  >匿名</van-checkbox
                >
              </template>
            </van-field>
          </div>
          <div class="phone-wrap">
            <van-field
              v-model="phone"
              class="phone"
              type="tel"
              name="phone"
              label=""
              placeholder="请输入手机号方便管理员联系到您"
            >
            </van-field>
          </div>
          <!-- <div style="height: 220rpx"></div> -->

          <div class="submit-parent" style="margin: 16px">
            <van-button
              class="submit"
              round
              block
              type="info"
              native-type="submit"
              >提交</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'
// import * as constant from '../../api/constant'
import { Toast, Dialog } from 'vant'

export default {
  data () {
    return {
      id: null,
      roomId: -1,
      bookId: -1,
      maxImageNum: 5,
      isShowAdd: true,
      faultTypeList: [],
      faultCause: '',
      faultImage: [],
      anonymous: '',
      phone: '',
      anonymousArr: [],
      textareaVal: '',
      uploader: [],
      pageOption: {
        total: 0,
        page_no: 1,
        page_size: 100
      },
      selt: 'selt',
      detailObj: {}
    }
  },
  mounted () {
    this.detailObj = this.$route.query
    this.getFaultTypeList()
  },
  computed: {

  },
  methods: {
    beforeRead (file) {
      if (file.type !== 'image/png' &&
          file.type !== 'image/jpg' &&
          file.type !== 'image/jpeg') {
        Toast('请上传png或jpg格式图片')
        return false
      }
      return true
    },
    // 获取故障原因类型
    getFaultTypeList () {
      const para = {
        page_no: this.pageOption.page_no,
        page_size: this.pageOption.page_size
      }
      api
        .axiosRequest(api.urlList.getFaultTypeList, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            this.faultTypeList = res.list
          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    // 提交
    onSubmit (values) {
      // 故障原因
      if (this.textareaVal === '') {
        Toast.fail('请填写意见反馈')
        return false
      }

      // phone
      if (this.phone) {
        const mobile = /^[1][3,4,5,7,8,9][0-9]{9}$/
        if (!mobile.test(this.phone)) {
          Toast.fail('请填写正确的手机号')
          return false
        }
      }
      // 上传
      const para = {
        reason: this.textareaVal,
        type_id: [],
        room_id: this.detailObj.roomId,
        book_id: this.detailObj.bookId,
        pic_url_list: []
      }
      if (this.anonymous) {
        para.anonymous = 1
      }
      if (this.phone) {
        para.phone = this.phone
        localStorage.setItem('msgPhone', this.phone)
        // wx.setStorageSync('msgPhone', this.data.phone)
      }
      let imgFlag = 0
      if (this.uploader.length > 0) {
        this.uploader.forEach((item) => {
          // arr.push(item.file)

          const paraImg = {
            formData: true,
            file: item.file,
            json: api.getPublicPara(false)

          }
          api
            .axiosRequest(api.urlList.uploadFile, paraImg)
            .then((res) => {
              if (res.code === common.resCode.OK) {
                imgFlag = imgFlag + 1
                para.pic_url_list.push(res.path)

                if (imgFlag === this.uploader.length) {
                  this.addFeedBack(para)
                }
              } else {
                utils.judgeBackMsg(res)
              }
            })
            .catch((e) => {
              console.log('error log:', e)
            })
        })

        return false
      } else {
        this.addFeedBack(para)
      }
    },
    // 故障上报 除图片
    addFeedBack (para) {
      api
        .axiosRequest(api.urlList.addFeedBack, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            Dialog.alert({
              title: '提交成功',
              message: '您的意见反馈已提交成功'
            }).then(() => {
              // on close
              this.onClickLeft()
            })
          } else {
            Toast.fail('提交失败')
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    seltFaultType (val) {
      const arr = JSON.parse(JSON.stringify(this.faultTypeList))
      const faultTypeItem = arr[val]
      faultTypeItem.set_selt = !faultTypeItem.set_selt
      this.faultTypeList[val] = faultTypeItem
      this.faultTypeList = arr
    },
    deleteImage () {

    },
    chooseImage () {

    },
    getAnonymous (val) {
      // true匿名选中 false未选中
    },
    faultCase () {
    },
    onClickLeft () {
      this.$router.go(-1)
    }

  }
}
</script>
<style scoped lang="scss">
.content_box {
  // width: 100%;
  .feedback_box {
    // width: 100%;
    padding: 0 1rem;
    margin-top: 1rem;
    .selt-fault-hint {
      height: 3.5625rem;
      line-height: 3.5625rem;
      // margin-left: 0.875rem;
      font-weight: 500;
      color: #666;
    }
    .fault-type-list-parent {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      // margin: 0 0.875rem 0 0.875rem;
    }
    .fault-type-item {
      box-sizing: border-box;
      height: 2.125rem;
      margin-right: 0.75rem;
      margin-bottom: 0.75rem;
      padding: 0.4375rem 0.75rem;
      border: 1px solid #afafaf;
      border-radius: 0.25rem;
      font-size: 0.875rem;
      color: #333;
    }
    .selt {
      border: 1px solid #0487fe;
      color: #0487fe;
    }
    .input-fault-case {
      box-sizing: border-box;
      height: 6.25rem;
      width: 21.6875rem;
      border: 1px solid #dfdfdf;
      border-radius: 0.25rem;
      // margin: 0 0 0 0.875rem;
      padding: 0.875rem 0.75rem;
      font-size: 0.875rem;
      color: #333;
      text-align: top;
    }
    .input-fault-case-placeholder {
      font-size: 0.875rem;
      color: #999;
    }
    .upload-fault-image-hint {
      font-size: 0.75rem;
      font-weight: 500;
      margin: 2rem 0 1.0625rem 0;
      color: #666;
    }
    .image-list-parent {
      // margin-left: 0.875rem;
      // margin-right: 0.875rem;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: flex-start;
    }
    .image-item {
      position: relative;
      width: 6.875rem;
      height: 6.875rem;
      margin-right: 0.3125rem;
      margin-bottom: 0.3125rem;
      background-color: #d8d8d8;
    }
    .fault-image {
      width: 100%;
      height: 100%;
    }
    .delete-image {
      position: absolute;
      top: 0.0625rem;
      right: 0.0625rem;
      font-size: 1.25rem;
      color: #fff;
    }
    .upload-image-btn {
      display: flex;
      // width: 9.375rem;
      // height: 4.25rem;
      // margin-left: 0.875rem;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      border: 0.0625rem solid #d9d9d9;
      border-radius: 0.25rem;
    }
    .upload-btn-icon {
      font-size: 2.1875rem;
      color: #aeaeae;
      margin-right: 0.875rem;
    }
    .upload-btn-text {
      font-size: 0.75rem;
      color: #999;
    }
    .submit-parent {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      height: 5.625rem;
      background: #fff;
    }
    .submit {
      width: 21.6875rem;
      height: 3.125rem;
      margin: auto;
      margin-top: 0.3125rem;
      line-height: 3.125rem;
      text-align: center;
      font-size: 1.25rem;
      font-weight: 500;
      color: #fff;
      border-radius: 1.5625rem;
      border: 1px solid #ff9d00;
      background-color: #ff9d00;
    }
    .anonymous-wrap {
      padding: 0.875rem 0.875rem 0.875rem 0;
    }
    .anonymous-wrap .van-cell {
      padding-left: 0;
    }
    .anonymousBtn {
    }
    .phone-wrap {
      box-sizing: border-box;
      // padding: 0 0.875rem;
    }
    .phone {
      // padding: 0.3125rem 0.3125rem 0.3125rem 0;
      border: 0.0625rem solid #d9d9d9;
      border-radius: 0.25rem;
    }
  }
}
</style>
